// action
import {
    DOCTOR_SIGNUP_REQUEST_LIST,
    DOCTOR_SIGNUP_REQUEST_LIST_FAIL,
    DOCTOR_SIGNUP_REQUEST_LIST_SUCCESS,
    DOCTOR_SIGNUP_REQUEST_LIST_RESET
} from '../action/doctorSignupRequestListAction'

// initialState
const initialState = {
    apiState: "",
    data: [],
    pagination: {},
}

export default function (state = initialState, action) {
    switch (action.type) {
        case DOCTOR_SIGNUP_REQUEST_LIST:
            return {
                ...state,
                apiState: "loading"
            }
        case DOCTOR_SIGNUP_REQUEST_LIST_FAIL:
            return {
                ...state,
                apiState: "error"
            }
        case DOCTOR_SIGNUP_REQUEST_LIST_SUCCESS:
            return {
                ...state,
                apiState: "success",
                data: action.response.data.data.result,
                pagination: action.response.data.data.pagination,
            }
        case DOCTOR_SIGNUP_REQUEST_LIST_RESET:
            return initialState
        default:
            return state
    }
}